module.exports = __webpack_public_path__ + "img/community-discord.fd683c96.svg";